(() => {
  const track = document.getElementById('se-latest-track');
  if (!track) return;
  const buttons = document.querySelectorAll('[data-latest-direction]');
  const update = () => buttons.forEach(button => {
    button.disabled = Number(button.dataset.latestDirection) < 0
      ? track.scrollLeft <= 1
      : track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
  });
  buttons.forEach(button => button.addEventListener('click', () => {
    track.scrollBy({left: Number(button.dataset.latestDirection) * track.clientWidth,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }));
  track.addEventListener('scroll', update, {passive: true});
  new ResizeObserver(update).observe(track);
  update();
})();
